<mat-card class="summary-card ytd-total">
    <div class="summary-title ytd-total">YEAR TO DATE (Up till yesterday)</div>
    <div class="summary-content">
        <!-- Repeat for each metric -->
		<div class="summary-metric">
			<span class="metric-label">TOTAL SALES</span>
			<span class="metric-value">{{ ytdSales | currency:'USD':'symbol':'1.0-0' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">TOTAL ORDERS / ITEMS</span>
			<span class="metric-value">{{ ytdOrdersItems }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SALES VALUE / ITEM</span>
			<span class="metric-value">{{ ytdSalesValuePerItem | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">AVERAGE ORDER $</span>
			<span class="metric-value">{{ ytdAverageOrder | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SUSHI SALES</span>
			<span class="metric-value">{{ ytdSushiSales | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SUSHI ITEM SOLD</span>
			<span class="metric-value">{{ ytdSushiItemsSold | number:'0.0-0' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">BENTO SALES</span>
			<span class="metric-value">{{ ytdBentoSales | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">BENTO ITEM SOLD</span>
			<span class="metric-value">{{ ytdBentoItemsSold | number:'0.0-0' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">COMMON SALES</span>
			<span class="metric-value">{{ ytdCommonSales | currency:'USD':'symbol':'1.2-2'}}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">COMMON ITEM SOLD</span>
			<span class="metric-value">{{ ytdCommonItemsSold | number:'0.0-0'}}</span>
		</div>
    </div>
</mat-card>